import {create} from 'zustand';
import {configApi} from '../services/api/configApi';

const propsKey = (type, orgUnitId) => orgUnitId ? `${type}_${orgUnitId}` : type;

export const useConfigStore = create((set, get) => ({
  properties: [],
  isLoading: false,

  fetchAll: async () => {
    set({isLoading: true});
    try {
      const response = await configApi.getAll();
      set({properties: response.data.data || []});
    } finally {
      set({isLoading: false});
    }
  },

  fetchByType: async (type, orgUnitId) => {
    set({isLoading: true});
    try {
      const response = await configApi.getByType(type, orgUnitId);
      const fetched = response.data.data || [];
      const key = propsKey(type, orgUnitId);
      // Keep properties that don't match this type+orgUnit combo
      const existing = get().properties.filter(p => propsKey(p.type, p.orgUnitId) !== key);
      set({properties: [...existing, ...fetched]});
    } finally {
      set({isLoading: false});
    }
  },

  updateProperties: async (type, entries, orgUnitId) => {
    const payload = {type, properties: entries};
    if (orgUnitId) {
      payload.orgUnitId = orgUnitId;
    }
    const response = await configApi.update(payload);
    const updated = response.data.data || [];
    const key = propsKey(type, orgUnitId);
    const existing = get().properties.filter(p => propsKey(p.type, p.orgUnitId) !== key);
    set({properties: [...existing, ...updated]});
    return updated;
  },

  getProperty: (type, code, orgUnitId) => {
    const props = get().properties;
    const prop = orgUnitId
      ? props.find(p => p.type === type && p.code === code && p.orgUnitId === orgUnitId)
      : props.find(p => p.type === type && p.code === code);
    return prop?.value || '';
  },
}));
